import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { DelegueTutelleDetailPage } from "..";
import { PersonnelTutelleApi } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

interface IDelegueTutelleItemPageProps {}

export const DelegueTutelleItemPage: React.FunctionComponent<IDelegueTutelleItemPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const api = useApiService(PersonnelTutelleApi);
  const [displayName] = useApiEffect(() => api.personnelTutelleGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Referents), route: ERoutes.delegueTutelle },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsDelegueTutelle"
        onChange={newTabId => history.push(`${ERoutes.delegueTutelle}/${id}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.delegueTutelle}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<DelegueTutelleDetailPage idDelegueTutelle={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
